import {
   ShipmentTypes, ShipmentModes,
   BillingParty,
   Status,
   Reference,
   Milestones
} from '@library/common/models';

export interface ShipmentSnapshotInterface {
   shipType: ShipmentTypes;
   mode: ShipmentModes;
   hawb: string;
   references: Reference[];
   servicelevel: string;
   statuses: Status[];
   milestones?: {};
   shipper: BillingParty;
   consignee: BillingParty;
   bill_to: BillingParty;
}

export interface ShipmentSnapshot extends ShipmentSnapshotInterface {
   toString: () => string;
}

export class ShipmentSnapshot {
   shipType: ShipmentTypes;
   mode: ShipmentModes;

   constructor( s: any = {} ) {
      this.shipType = s['shipType'] || 'domestic';
      this.mode = s['mode'] || 'road';

      this.hawb = s['hawb'];
      this.servicelevel = s['servicelevel'];

      this.references = [];
      if ( s['references'] ) {
         this.references = s['references'].map( r => new Reference( r ));
      }
      this.statuses = (s['statuses'] || []).map( stat => new Status( stat ));

      this.milestones = Milestones( s['mode'], s['milestones'] );

      this.shipper = new BillingParty( s['shipper'] );
      this.consignee = new BillingParty( s['consignee'] );
      this.bill_to = new BillingParty( s['bill_to'] );
   }

   public toString = (): string => {
      return [
         this.hawb,
         this.servicelevel,
         this.references.map( r => r.toString()).join('◬'),
         this.statuses.map( s => s.toString()).join('◬'),
         (this.shipper) ? this.shipper.toString() : '',
         (this.consignee) ? this.consignee.toString() : '',
         (this.bill_to) ? this.bill_to.toString() : '',
      ].join('◬').toLowerCase();
   }
}

export class DefaultShipmentSnapshot extends ShipmentSnapshot {
   constructor() {
      super();

      this.shipType = 'domestic';
      this.mode = 'road';
      this.hawb = '0000000000';
      this.references = [];
      this.servicelevel = 'Shipment';
      this.statuses = [];
      this.milestones = Milestones( this.mode );

      this.shipper = {
         id: -1,
         name: 'Shipper Name',
         address1: '123 Street St',
         city: 'Anytown',
         state: 'Anywhere',
         country: 'US',
      };

      this.consignee = {
         id: -1,
         name: 'Consignee Name',
         address1: '123 Brick Rd',
         city: 'Somewhere',
         state: 'Over the rainbow',
         country: 'US',
      };
   }
}
